import classNames from "@casino/external/classNames";

type Props = {
  selected: boolean;
  onClick: () => void;
  isBitcasino: boolean;
};

const ToggleButton: FC<Props> = ({
  children,
  selected,
  onClick,
  isBitcasino,
}) => (
  <div
    className={classNames(
      "inline-container flex h-10 items-center justify-center rounded-sm font-medium",
      "m-1 cursor-pointer border border-solid border-border hover:bg-primary hover:text-white",
      isBitcasino && "hover:text-background",
      selected && "bg-primary text-white",
      selected && isBitcasino && "bg-primary text-background",
    )}
    onClick={onClick}
  >
    {children}
  </div>
);

export default ToggleButton;
